import type { FormModalPayload } from '@/lib/utils/modal-event';

export type FormContent = {
  formId?: number;
  formSlugId?: string;
  badge?: string;
  title?: string;
  description?: string;
  successTitle?: string;
  successDescription?: string;
  successCTA?: {
    label?: string;
    url?: string;
    type?: 'Button' | 'Link';
  };
  thankYouUrl?: string;
};

export type LinkFieldsInput = {
  destination?: 'URL' | 'Page' | 'Form';
  form?: {
    fields?: {
      marketoFormId?: number;
      slugId?: string;
      badge?: string;
      title?: string;
      description?: string;
      successTitle?: string;
      successDescription?: string;
      successCTA?: {
        fields?: {
          label?: string;
          url?: string;
          type?: 'Button' | 'Link';
        };
      };
      thankYouUrl?: string;
    };
  };
};

export const toFormModalPayload = (
  formContent: FormContent,
  extras: Pick<FormModalPayload, 'ctaId' | 'productId'> = {},
): FormModalPayload | null => {
  if (!formContent.formId || !formContent.formSlugId) {
    return null;
  }

  return {
    formId: formContent.formId,
    slugId: formContent.formSlugId,
    ctaId: extras.ctaId,
    productId: extras.productId,
    badge: formContent.badge,
    title: formContent.title,
    description: formContent.description,
    successTitle: formContent.successTitle,
    successDescription: formContent.successDescription,
    successCTA: formContent.successCTA,
    thankYouUrl: formContent.thankYouUrl,
  };
};

export const buildFormContentFromLinkFields = (linkFields?: LinkFieldsInput): FormContent => {
  if (linkFields?.destination !== 'Form' || !linkFields.form?.fields) {
    return {};
  }

  const formFields = linkFields.form.fields;
  if (!formFields.marketoFormId) {
    return {};
  }

  return {
    formId: formFields.marketoFormId,
    formSlugId: formFields.slugId || formFields.marketoFormId.toString(),
    badge: formFields.badge,
    title: formFields.title,
    description: formFields.description,
    successTitle: formFields.successTitle,
    successDescription: formFields.successDescription,
    successCTA: formFields.successCTA?.fields
      ? {
          label: formFields.successCTA.fields.label,
          url: formFields.successCTA.fields.url,
          type: formFields.successCTA.fields.type,
        }
      : undefined,
    thankYouUrl: formFields.thankYouUrl,
  };
};
